import styled from 'styled-components';
import { Container, Row, Col } from 'reactstrap';

export const FullWidthContainer = styled(Container)`
  padding-left: 0;
  padding-right: 0;
  overflow-x: hidden;
`;

export const NoGutterRow = styled(Row)`
  margin: 0;
`;

export const NoPaddingCol = styled(Col)`
  padding: 0px !important;
`;



// WEBPACK FOOTER //
// ./src/components/Grid/FullWidthGrid.tsx